import { render, staticRenderFns } from "./NutritionInfo.vue?vue&type=template&id=07f1a1d4&scoped=true&"
import script from "./NutritionInfo.vue?vue&type=script&lang=js&"
export * from "./NutritionInfo.vue?vue&type=script&lang=js&"
import style0 from "./NutritionInfo.vue?vue&type=style&index=0&id=07f1a1d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f1a1d4",
  null
  
)

/* custom blocks */
import block0 from "./NutritionInfo.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports